import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IRemoteRefreshSchedule } from '../types/IRemoteRefreshSchedule';

export interface ICreateRemoteRefreshScheduleParams {
  targetId: string;
  definition: string;
  refreshType: string; // RemoteRefreshTypes
  schedule?: IRemoteRefreshSchedule;
}

export class CreateRemoteRefreshScheduleRequest extends Request<ICreateRemoteRefreshScheduleParams, IResult> {
  constructor(params: ICreateRemoteRefreshScheduleParams) {
    super('createRemoteRefreshSchedule', params);
  }
}
